import { graphql } from "@opensea/graphql"

export const CreateCollectionOfferTraitInputFragment = graphql(`
  fragment CreateCollectionOfferTraitInput on Collection {
    attributes(limit: $attributesLimit) {
      items {
        traitType
        values {
          value
          count
        }
        isNumericRange
      }
    }
  }
`)
